import {Box} from '@dropbox/dig-foundations';
import type {Workstream} from 'client';

import {EditableSummary} from './EditableSummary';
import {canEditUpdate} from './EditableUpdatePost';
import {useUpdateSummary} from './useUpdateSummary';

/**
 * /workstreams: the detail page's opening summary — the latest update's
 * TL;DR (the same one the open card shows), editable while the update is.
 * Short updates read as their own summary, so nothing shows for them.
 */
export const LatestUpdateSummary = ({workstream}: {workstream: Workstream}) => {
  const latest = workstream.updates?.[0];
  const summary = useUpdateSummary(latest);
  if (!latest || (!summary.summary && !summary.pending)) return null;
  return (
    <Box marginBottom="24">
      <EditableSummary
        update={latest}
        state={summary}
        editable={canEditUpdate(workstream, latest)}
        quote
      />
    </Box>
  );
};
